import { render, staticRenderFns } from "./CustomTechnicianDetails.vue?vue&type=template&id=0f3afee9&scoped=true"
import script from "./CustomTechnicianDetails.vue?vue&type=script&lang=js"
export * from "./CustomTechnicianDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomTechnicianDetails.vue?vue&type=style&index=0&id=0f3afee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3afee9",
  null
  
)

export default component.exports